import { render, staticRenderFns } from "./ManageOktaFederations.vue?vue&type=template&id=622c7a08&"
import script from "./ManageOktaFederations.vue?vue&type=script&lang=js&"
export * from "./ManageOktaFederations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports